import { render, staticRenderFns } from "./LoginDialog.vue?vue&type=template&id=1f47ca36"
import script from "./LoginDialog.vue?vue&type=script&lang=js"
export * from "./LoginDialog.vue?vue&type=script&lang=js"
import style0 from "./LoginDialog.vue?vue&type=style&index=0&id=1f47ca36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports